/**
 * True when the latest assistant message still has client tool parts waiting for execution
 * (no output / output-error handled yet). Prevents build-stream POST while build/writeFile run.
 */

import {
  isServerExecutedPrototyperTool,
  toolNameFromPartType,
} from './serverExecutedPrototyperTools';

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null;
}

function toolPartIsComplete(p: Record<string, unknown>): boolean {
  const state = p.state;
  return state === 'output-available' || state === 'output-error';
}

function partIsPendingClientTool(part: Record<string, unknown>): boolean {
  const t = part.type;
  if (typeof t !== 'string') return false;
  if (!(t === 'dynamic-tool' || t.startsWith('tool-'))) return false;

  const fromType = toolNameFromPartType(t);
  const toolName =
    typeof part.toolName === 'string'
      ? part.toolName
      : fromType;
  if (toolName && isServerExecutedPrototyperTool(toolName)) return false;

  return !toolPartIsComplete(part);
}

export function lastAssistantHasPendingClientTools(
  messages: readonly unknown[] | undefined,
): boolean {
  if (!Array.isArray(messages) || messages.length === 0) return false;

  let msg: unknown;
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (isRecord(m) && m.role === 'assistant') {
      msg = m;
      break;
    }
  }
  if (!isRecord(msg)) return false;

  const parts = msg.parts;
  if (!Array.isArray(parts)) return false;

  for (const part of parts) {
    if (!isRecord(part)) continue;
    if (partIsPendingClientTool(part)) return true;
  }
  return false;
}
